﻿$.fn.dxCtrlFichier2Thumb = function custom_dxCtrlFichier2Thumb(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlfichier2thumb dx-ctrl");
        this.createInstance(new cdxCtrlFichier2Thumb(this, option));
    }
    return this;
}

window.cdxCtrlFichier2Thumb = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var timeOutResize = null
    window.setTimeout(function () {
        resizeObserver.mAdd(container, function () {
            window.clearTimeout(timeOutResize)
            timeOutResize = window.setTimeout(function () {
                if (oldHeight != container.innerHeight() || oldWidth != container.innerWidth()) {
                    Me.load()
                    oldHeight = container.innerHeight()
                    oldWidth = container.innerWidth()
                }
            }, 500)
        })
    }, 1000)


    var oldHeight = null
    var oldWidth = null
    function mConstruit() {
        container.empty();
        Me.load()
        if (typeof option.onClick != 'undefined') {
            container.css("cursor", "pointer")
            container.on("click", function (e) {
                e.stopPropagation()
                option.onClick(option.urlFile)
            })
        }
        oldHeight = container.innerHeight()
        oldWidth = container.innerWidth()
    }

    this.isLoaded = false
    this.load = function () {
        container.empty()
        container.css({ "border-radius": ((typeof option.borderRadius == 'undefined') ? "0" : option.borderRadius + "px"), position: "relative" })
        if (typeof option.title != 'undefined') $("<div style='position:absolute;top:3px;left:3px;font-variant: small-caps;z-index:10;font-size:130%;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;width:100%;color:" + theme.backgroundcolorTooltip.replace("rgb(", "rgba(").replace(")", ",0.5)") + ";font-weight:bold;'>" + option.title + "</div>").appendTo(container)
        if (container.is(":visible") && container.innerWidth() <= 0) { window.setTimeout(function () { Me.load() }, 20); }
        else {
            if (typeof option.urlFile == "undefined" || option.urlFile == null) {
                $("<i style='width:100%;height:100%;font-size:" + (container.innerWidth() * 2 / 3) + "px;display:flex;align-items:center;justify-content:center;color:" + theme.color.replace("rgb(", "rgba(").replace(")", ",0.1)") + ";' class='fas fa-image'/>").appendTo(container)
            } else {
                var fichier = new cFichier(option.bddCtrl, option.urlFile)
                var $elementImage = fichier.mGetElementImage(container.outerWidth() - 3, container.outerWidth() - 3, false).appendTo(container)
                $elementImage.css({ "border-radius": ((typeof option.borderRadius == 'undefined') ? "0" : option.borderRadius + "px") })
                if (!fichier.mIsImage()) $elementImage.css({ "width": "100%", "height": "100%", "font-size": (container.innerWidth() * 2 / 3) + "px", "display": "flex", "align-items": "center", "justify-content": "center" })
            }
            this.isLoaded = true
        }
    }

    this.element = function () { return container }

    mConstruit();
}